import { createActionGroup, props } from '@ngrx/store';

export const passwordlessLoginActions = createActionGroup({
  source: 'Passwordless Login',
  events: {
    'Link Requested': props<{ email: string }>(),
    'Link Requested Success': props<{ authMethod: 'email' }>(),
  },
});
